import React, { useState } from "react";
import { Link } from "react-router-dom";


const SliderContactUs = () => {
  // Use a state hook to manage the form's data.
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    companyName: "",
    mobileNumber: "",
    requirements: "",
  });

  // This function updates the state whenever an input field changes.
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // This is the function that will send the data to your backend API.
  const handleSubmit = async (e) => {
    // Prevent the default form submission behavior (page reload).
    e.preventDefault();

    // The URL of your .NET backend's contactus endpoint.
    // Use the http profile port from launchSettings.json (5108)
    // or the IIS Express port (58826) depending on how you run your backend.
    const apiUrl = "http://localhost:58826/api/contact/contactus";

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        // If the response status is 200-299, it's a success.
        const result = await response.json();
        alert(result.message);
        // Clear the form fields after a successful submission.
        setFormData({
          fullName: "",
          email: "",
          companyName: "",
          mobileNumber: "",
          requirements: "",
        });
      } else {
        // If the response status is an error, parse and display it.
        const errorData = await response.json();
        const errorMessage = errorData.errors
          ? JSON.stringify(errorData.errors)
          : "An unknown error occurred.";
        alert(`Submission failed: ${errorMessage}`);
      }
    } catch (error) {
      // Catch any network or other errors.
      console.error("Error submitting form:", error);
      alert("An error occurred. Please try again later.");
    }
  };

  return (
    <>
      

      <div className="max-w-3xl mx-auto px-4 py-16">
        
        <form className="space-y-6" onSubmit={handleSubmit}>
          <input
            type="text"
            name="fullName"
            placeholder="Full Name*"
            className="w-full border-b p-2 focus:outline-none"
            value={formData.fullName}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Email*"
            className="w-full border-b p-2 focus:outline-none"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="companyName"
            placeholder="Company Name*"
            className="w-full border-b p-2 focus:outline-none"
            value={formData.companyName}
            onChange={handleChange}
            required
          />
          <input
            type="tel"
            name="mobileNumber"
            placeholder="Mobile Number"
            className="w-full border-b p-2 focus:outline-none"
            value={formData.mobileNumber}
            onChange={handleChange}
          />
          <textarea
            name="requirements"
            placeholder="Share your requirements*"
            className="w-full border-b p-2 focus:outline-none"
            value={formData.requirements}
            onChange={handleChange}
            required
          ></textarea>
          <button type="submit" className="bg-[#8b0000] text-white px-6 py-2 rounded">
            Submit
          </button>
        </form>
      </div>
    </>
  );
};

export default SliderContactUs;
